import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import { kebabCase } from "lodash";

// import PayhereLogo from "../../../../../images/PayHereLogo.png";
// import StripeLogo from "../../../../../images/stripe.png";

const TableDataRow = ({ item }) => {
  const expireAt = moment(item.expiresAt).format("YYYY-MM-DD");
  const publishedAt = moment(item.publishedAt).format("YYYY-MM-DD");
  const postId = item.id;
  const pricingPackage = item.pricingTier.id ?? "";
  const subscriptionStatus = item.subscriptionStatus;
  // const paymentGateway = "payhere";

  return (
    <TableRow>
      <TableCell align="center">{expireAt}</TableCell>
      <TableCell align="center">{publishedAt}</TableCell>
      <TableCell align="center">{postId}</TableCell>
      <TableCell align="center">{pricingPackage}</TableCell>
      {/* <TableCell align="center">
        {paymentGateway === "payhere" ? (
          <img src={PayhereLogo} alt="payhere" className="payhere" />
        ) : (
          <img src={StripeLogo} alt="payhere" className="stripe" />
        )}
      </TableCell> */}
      <TableCell
        align="center"
        className={`subscription-status ${kebabCase(subscriptionStatus)}`}
      >
        <span>{subscriptionStatus}</span>
      </TableCell>
    </TableRow>
  );
};

const SubscriptionExpirationTable = ({ data }) => {
  return (
    <TableContainer className="subscription-expiration-table">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">expiration date</TableCell>
            <TableCell align="center">published date</TableCell>
            <TableCell align="center">post id</TableCell>
            <TableCell align="center">package</TableCell>
            {/* <TableCell align="center">payment gateway</TableCell> */}
            <TableCell align="center">subscription status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(data) &&
            data.map((item) => <TableDataRow key={item.id} item={item} />)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SubscriptionExpirationTable;
